import { render, staticRenderFns } from "./TeacherContent.vue?vue&type=template&id=1655fe02&"
import script from "./TeacherContent.vue?vue&type=script&lang=ts&"
export * from "./TeacherContent.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports